import svgUrl from "ni:svgr;JcPYqBTjqHFDrmmAHHk5ZxQPCub7j4To8owJfp7fPZg";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiSearchCompanySIcon = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 5.66675C2 5.11446 2.44772 4.66675 3 4.66675H6.66667V14.0001H3C2.44771 14.0001 2 13.5524 2 13.0001V5.66675Z" fill="var(--tbl--colors--icons--enrich--tertiary)" /><path d="M8 3C8 2.44772 8.44772 2 9 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H8V3Z" fill="var(--tbl--colors--icons--enrich--primary)" /></svg>;
const Memo = memo(UiSearchCompanySIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiSearchCompanySIcon)";
}